import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Platform } from '@ionic/angular';
import { ImageVariantEnum } from 'src/app/product-detail/models/image-variant.enum';
import { ProductDetailTagsService } from 'src/app/product-detail/services/product-detail-tags.service';
import {
  getAlternativeThumbnail,
  getFirstImageURL,
} from 'src/app/product-detail/utils/product-images.util';
import { TagProduct } from '@app/shared-product/components/usf-product-tag-list/models/tag-product.model';
import { NavigationHelperService } from 'src/app/shared/helpers/navigation.helpers.service';
import { PlatformService } from '@panamax/app-state';
import { ConfirmationCartItem } from '../../../models/order-confirmation-view-model';
import { SubbedItem } from 'src/app/order/models/submitted-order-view-model';
import { FEATURES } from '../../../../shared/constants/splitio-features';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-order-confirmation-item',
  templateUrl: './order-confirmation-item.component.html',
  styleUrls: ['./order-confirmation-item.component.scss'],
})
export class OrderConfirmationItemComponent implements OnInit, OnChanges {
  @Input() cartItem: ConfirmationCartItem;
  @Input() subbedItem?: SubbedItem;
  @Input() isLast: any;
  @Input() navigationRestricted: boolean;
  @Input() availableToPromise?: boolean = false;

  atpFeatureFlag = FEATURES.split_division_available_to_promise.name;

  maxDisplayTags = 5;
  thumbnailImageURL: string;
  displayTags: TagProduct[] = [];

  constructor(
    readonly platformService: PlatformService,
    private readonly navHelper: NavigationHelperService,
    private platform: Platform,
    private productDetailTagsService: ProductDetailTagsService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    if (this.platform.is('mobile') && !this.platform.is('tablet')) {
      this.maxDisplayTags = 2;
    }
    this.thumbnailImageURL = getFirstImageURL(
      this.cartItem?.productState,
      ImageVariantEnum.Thumbnail,
    );
    this.populateProductTags();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.productState?.currentValue) {
      this.thumbnailImageURL = getFirstImageURL(
        this.cartItem?.productState,
        ImageVariantEnum.Thumbnail,
      );
    }
    this.populateProductTags();
  }

  populateProductTags() {
    this.displayTags = this.productDetailTagsService.getDisplayTags(
      this.cartItem?.productState,
      this.cartItem?.productInventory,
      this.cartItem?.productContract,
      this.cartItem?.customerPill,
    );
  }
  productClickHandler() {
    this.navHelper.routeToProductDetails(
      this.cartItem?.productState.productNumber,
    );
  }

  getAternativeThumbnail = (thumbnailImageURL: string): string =>
    getAlternativeThumbnail(this.cartItem?.productState, thumbnailImageURL);
}
